<template>
  <div class="template">
    <div class="header">
      <div class="left">查看电子底单</div>
      <div class="right"></div>
    </div>  
    <div class="sheet">
        <div class="sheetIcon"><img src="@/assets/images/yd_Icon.png" /></div>
        <div class="sheet-header flex">
            <div class="sheet-header-time">
            {{orderInfo.print_time}}
            </div>
            <div class="sheet-header-branch">
            始发网点：{{orderInfo.sender_branch}}
            </div>
            <div class="sheet-header-placeholder"></div>
            <div class="sheet-header-ticket">
            标记码：{{orderInfo.ticket_id}}
            </div>
        </div>
        <div class="sheet-traffic">
            <div class="sheet-traffic-code flex">
            <div class="sheet-traffic-code-item">
                {{orderInfo.position}}
            </div>
            <div class="sheet-traffic-code-item">
                {{orderInfo.position_two}}
            </div>
            <div class="sheet-traffic-code-item">
                {{orderInfo.position_three}}
            </div>
            </div>
            <div class="sheet-traffic-content flex">
            <div class="sheet-icon">
                交
            </div>
            <div class="sheet-traffic-value">
                {{orderInfo.package_wdjc}}
            </div>
            </div>
        </div>
        <div class="sheet-barcode flex">
            <!-- <img class="sheet-barcode-image" style="width:250px;height:60px" :src="'https://u-openapi.yundasys.com/file/getBarImg?str='+orderInfo.mail_no+'&width=165&height=48'" /> -->
            <svg ref="barcodeOne"></svg>
            <div class="sheet-barcode-code">
            {{orderInfo.mail_no}}
            </div>
        </div>
        <div class="sheet-address flex">
            <div class="sheet-address-left">
            <div class="sheet-address-user flex">
                <div class="sheet-icon">
                收
                </div>
                <div class="sheet-address-content">
                <div class="flex">
                    <div class="sheet-address-name">
                    {{orderInfo.receiver_name}}
                    </div>
                    <div class="sheet-address-phone">
                    {{orderInfo.receiver_phone}}
                    </div>
                </div>
                <div class="sheet-address-value ellipsis-4">
                    {{orderInfo.receiver_province}}{{orderInfo.receiver_city}}{{orderInfo.receiver_district}}{{orderInfo.receiver_address}}
                </div>
                </div>
            </div>
            <div class="sheet-address-user flex">
                <div class="sheet-icon">
                寄
                </div>
                <div class="sheet-address-content">
                <div class="flex">
                    <div class="sheet-address-name">
                    {{orderInfo.sender_name}}
                    </div>
                    <div class="sheet-address-phone">
                    {{orderInfo.sender_phone}}
                    </div>
                </div>
                <div class="sheet-address-value ellipsis-4">
                    {{orderInfo.sender_province}}{{orderInfo.sender_city}}{{orderInfo.sender_district}}{{orderInfo.sender_address}}
                </div>
                </div>
            </div>
            </div>
            <div class="sheet-address-right">
            <div class="sheet-address-right-placeholder">
                <!-- <img class="sheet-address-image" :src="'https://u-openapi.yundasys.com/file/getBarImg?str='+orderInfo.mail_no+'&width=165&height=48'" /> -->
                <svg ref="barcodeTwo" class="sheet-address-image"></svg>
            </div>
            </div>
        </div>
        <div class="sheet-content">
            <div class="sheet-content-note ellipsis-4">
            备注：{{orderInfo.item_note ? orderInfo.item_note : '无'}}
            </div>
            <div class="sheet-content-row flex">
            <div class="sheet-content-item">
                品类：{{orderInfo.item_type}}*1
            </div>
            <div class="sheet-content-item" v-if="orderInfo.goods_weight">
                重量：{{orderInfo.goods_weight}}KG
            </div>
            <div class="sheet-content-item">
                <div if="orderInfo.express_type_tkdisplay">
                {{orderInfo.express_type_tkdisplay}}
                </div>
            </div>
            <!-- <div class="sheet-content-item"></div> -->
            </div>
            <div class="sheet-content-row flex">
            <div class="sheet-content-item">
                签收时间：
            </div>
            <div class="sheet-content-item">
                签收人：
            </div>
            <div class="sheet-content-item sheet-content-icon">
                已验视
            </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import request from "@/util/request";
import setTemp from "../api/setTemplate";
import util from "@/util/util";
import JsBarcode from "jsbarcode";
export default {
  name:'electronicSheet',
  data() {
    return {
    orderId: null,
    orderInfo: {
      print_time: null /** 打印时间 */,
      sender_branch: null /** 始发网点 */,
      ticket_id: null /** 标记码 */,
      position: null /** 一段码 */,
      position_two: null /** 二段码 */,
      position_three: null /** 三段码 */,
      package_wdjc: null /** 交通 */,
      mail_no: null /** 运单号 */,
      receiver_name: null /** 收件人姓名 */,
      receiver_phone: null /** 收件人联系电话 */,
      receiver_province: null /** 收件人省份 */,
      receiver_city: null /** 收件人城市 */,
      receiver_district: null /** 收件人区县 */,
      receiver_address: null /** 收件人详细地址 */,
      sender_name: null /** 寄件人姓名 */,
      sender_phone: null /** 寄件人联系电话 */,
      sender_province: null /** 寄件人省份 */,
      sender_city: null /** 寄件人城市 */,
      sender_district: null /** 寄件人区县 */,
      sender_address: null /** 寄件人详细地址 */,
      item_note: null /** 备注 */,
      item_type: null /** 物品类型 */,
      goods_weight:null/** 物品重量 */,
      sign_time: null /** 签收时间 */,
      sign_receiver_name: null /** 签收人 */,
      express_type_tkdisplay: null /** TK-智橙网 */,
    },
    };
  },
  created() {

  },
  mounted(){
    this.getdata();
  }, 
  methods: {
    // 绘制二维码
    generateBarcode(svgId,value,width,height) {
      // 使用 JsBarcode 生成条形码
      JsBarcode(svgId, value, {
        format: "CODE128", // 条形码格式
        lineColor: "#000", // 条形码颜色
        width: width,          // 条形码宽度
        height: height,       // 条形码高度
        displayValue: false // 是否显示条形码值
      });
    },
    getdata(){
     request.post(this,{
        action:'kdyserver.order.queryOrderDeliverySlip',
        data:{
            account_id: util.getCookie("account_id"),
            order_id: this.$route.query.id,
        }},{'openid': '2017001127','content-type': 'application/json'}
        
      ).then(res=>{
        if(res.success && res.body.code === 200){
            const data = res.body.data ?? {}
            const orderInfo = Object.keys(this.orderInfo).reduce(
            (info, key) => {
                key in data && (info[key] = data[key])
                return info
            },
            {}
            )
            this.orderInfo = orderInfo;
            this.generateBarcode(this.$refs.barcodeOne, orderInfo.mail_no, 2, 60); // 绘制条形码
            this.generateBarcode(this.$refs.barcodeTwo, orderInfo.mail_no, 2, 50);
        }
      })
    }
  }
};
</script>
<style lang="stylus" scoped>
  .header{
    border-bottom  1px solid #DCDFE6  
    line-height 50px
    display flex
    justify-content: space-between
    .left{
       font-size 16px;
       font-weight bold 
       color #2ea2fc
    }
    .right{
      font-size:14px;
      a{
        cursor: pointer;
        padding: 4px
        color #2ea2fc
        border:1px solid #2ea2fc
        border-radius: 6px
      }
    }
  }
.template {
  min-width: 980px;
  min-height: calc(100vh - 140px);
  padding: 10px 30px;
  .flex {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .ellipsis-4 {
        overflow: hidden;
        /* text-overflow: ellipsis; */
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        word-break: break-all;
    }
    .sheet {
        padding: 0 12px;
        background: white;
        width:360px;
        margin: 20px auto 0 auto;
        border:1px solid #E5E5E5;
        border-radius: 10px;
    }
    .sheetIcon{
        // float: left;
        img{
            width:102px;
            height: 36px;
        }
    }
    .sheet-header {
        padding: 4px 0 5px 0;
        line-height: 18px;
        border-bottom: 1px solid #222222;
        font-size: 10px;
    }
    .sheet-header-branch {
        margin-left: 6px;
    }
    .sheet-header-placeholder {
        flex: 1;
    }
    .sheet-traffic {
        padding-bottom: 13px;
        border-bottom: 1px solid #222222;
    }
    .sheet-traffic-code {
        margin-bottom: 8px;
        justify-content: center;
    }
    .sheet-traffic-code-item {
        line-height: 54px;
        text-align: center;
        font-size: 30px;
        font-weight: 500;
    }
    .sheet-traffic-code-item:nth-of-type(2) {
        margin: 0 18px;
    }
    .sheet-icon {
        flex: 0 0 32px;
        width: 32px;
        height: 32px;
        align-self: flex-start;
        line-height: 32px;
        text-align: center;
        border: 1px solid #222222;
        font-size: 28px;
        font-weight: 500;
    }
    .sheet-traffic-value {
        margin-left: 12px;
        font-size: 24px;
    }
    .sheet-barcode {
        flex-direction: column;
        padding: 4px 0;
        border-bottom: 1px solid #222222;
    }
    .sheet-barcode-image {
        width: 165px;
        height: 48px;
        margin-bottom: 4px;
    }
    .sheet-barcode-code {
        width: 165px;
        text-align: right;
        line-height: 22px;
        font-style: 14px;
    }
    .sheet-address {
        align-items: inherit;
        border-bottom: 1px solid #222222;
    }
    .sheet-address-left {
        flex: 1;
    }
    .sheet-address-right {
        flex: 0 0 79px;
        width: 79px;
        padding: 16px;
        box-sizing: border-box;
        border-left: 1px solid #222222;
    }
    .sheet-address-content {
        margin-left: 12px;
    }
    .sheet-address-user {
        padding: 12px;
        padding-left: 0;
        line-height: 22px;
        font-size: 14px;
    }
    .sheet-address-user:first-of-type {
        border-bottom: 1px solid #222222;
    }
    .sheet-address-name {
        margin-right: 9px;
    }
    .sheet-address-value {
        margin-top: 2px;
    }
    .sheet-address-right-placeholder {
        width: 48px;
        height: 165px;
        transform: translateX(100%);
    }
    .sheet-address-image {
        width: 165px;
        height: 48px;
        transform-origin: 0 0;
        transform: rotate(90deg) !important;
    }
    .sheet-content {
        padding: 4px 0 30px;
        line-height: 22px;
        font-size: 12px;
    }
    .sheet-content-note {
        font-size: 14px;
    }
    .sheet-content-row {
        margin-top: 12px;
    }
    .sheet-content-item {
        flex: 1;
    }
    .sheet-content-item:nth-of-type(2) {
    /* text-align: center; */
    }
    .sheet-content-icon {
        flex: 0 0 41px;
        width: 41px;
        height: 17px;
        line-height: 17px;
        text-align: center;
        border-radius: 2px;
        border: 1px solid #d1d1d1;
    }
}
</style>